import React, { useEffect, useState } from 'react'
import Navbar from './Navbar'
import HeroSection from './HeroSection';
import WhoWeAre from './WhoWeAre';
import Features from './Features';
import Template from './Template';
import PlanPricing from './PlanPricing';
import Faqs from './Faqs';
import Footer from './Footer';
import style from "./Home.module.css"
const Home = () => {
    const [activeTab, setActiveTab] = useState('Advantages')
    return (
        <div className={style.homecontainer} style={{ background: "white", color: "#15141c" }}>
            <Navbar />
            <main>
                <div id="hero"><HeroSection /></div>
                <div id="about"><WhoWeAre /></div>
                <div id="features"><Features /></div>
                <div id="template"><Template /></div>
                <div id="pricing"><PlanPricing /></div>
                <div id="faqs"><Faqs /></div>
            </main>
            <Footer />
        </div>
    )
}

export default Home
